module.exports = __webpack_public_path__ + "static/img/quark--pagecover-image.958de435.png";